export default "__VITE_ASSET__BxfCToIH__"